<template>
    <v-simple-table>
        <thead>
        <tr>
            <th>{{ $t('amount')}}</th>
            <th>{{ $t('creditor')}}</th>
            <th>{{ $t('remittanceInfo')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(t, i) in transfers" :key="t['@id']">
            <td>{{ $n(t['amount']['amount'] / 100, 'currency') }} {{ t['amount']['currency'] }}
            <td>
                <router-link v-if="creditors[i]" :to="{ name: 'PartyShow', params: { 'id': t['creditor'] } }">
                    {{ creditors[i]['sepaInfo']['name'] }}
                </router-link>
            </td>
            <td>{{ t['remittanceInfo']}}</td>
        </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
    export default {
        name: "CreditTransferTable",
        props: {
            transfers: {
                type: Array,
                default: () => []
            },
            creditors: {
                type: Array,
                default: () => []
            }
        }
    }
</script>

<style scoped>

</style>
